import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Pill } from "@/components/Bits";

export default function ParentMeals() {
  const [meals, setMeals] = useState([]);
  useEffect(() => { api.get("/meals").then(r => setMeals(r.data)); }, []);

  return (
    <div>
      <PageHeader eyebrow="Lunch" title="Today's menu" subtitle="What's on your child's plate." />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {meals.map(m => (
          <div key={m.menu_id} className="bg-white rounded-3xl border border-border p-5" data-testid={`p-meal-${m.menu_id}`}>
            <div className="text-5xl mb-2">🍱</div>
            <div className="text-xs text-ink-soft uppercase tracking-wider">{m.date}</div>
            <div className="space-y-2 text-sm mt-3">
              <div><span className="text-ink-soft">Breakfast:</span> <span className="font-medium">{m.breakfast}</span></div>
              <div><span className="text-ink-soft">Lunch:</span> <span className="font-medium">{m.lunch}</span></div>
              <div><span className="text-ink-soft">Snack:</span> <span className="font-medium">{m.snack}</span></div>
            </div>
            {m.allergens?.length > 0 && <div className="mt-3 flex gap-1 flex-wrap">{m.allergens.map(a => <Pill key={a} tone="danger">⚠ {a}</Pill>)}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
